<template>
  <div>
    <page-header
      :title="$t('restaurants')"
      :subtitle="$t('supplier_restaurants_subtitle')"
      icon="mdi-store-outline"
      icon-color="primary"
    >
      <template #actions v-if="!device.isMobile">
        <circle-button
          :loading="loading"
          @click="load"
          icon="mdi-refresh"
          color="primary"
          :small="false"
        />
      </template>
    </page-header>

    <div class="px-6 mt-2">
      <v-data-table
        :headers="headers"
        :items="restaurants"
        :loading="loading"
        :loading-text="$t('loading_data')"
        :search="search"
        class="striped-table ordera-box-shadow"
      >
        <template v-slot:top>
          <text-field
            v-model="search"
            :label="$t('search')"
            kind="search"
            style="max-width: 320px"
          />
        </template>

        <template v-slot:item.name="{ item }">
          <div class="d-flex align-center py-1">
            <v-avatar color="primary" size="32" class="mr-2">
              <v-icon color="white" size="18">mdi-store-outline</v-icon>
            </v-avatar>
            <span class="font-weight-medium">{{ toLatin(item.name) }}</span>
          </div>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import warehouseService from "@/services/warehouse";
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  name: "SupplierRestaurants",
  mixins: [hasSnackbar],

  data() {
    return {
      loading: false,
      restaurants: [],
      search: "",
    };
  },

  computed: {
    supplierId() {
      return this.$store.state.user?.user?.suppliers?.[0]?.id;
    },
    headers() {
      return [
        { text: this.$t("name"), value: "name" },
        { text: this.$t("city"), value: "city" },
        { text: this.$t("address"), value: "address" },
        { text: this.$t("phone"), value: "phone" },
        { text: this.$t("email"), value: "email" },
      ];
    },
  },

  mounted() {
    this.load();
  },

  methods: {
    async load() {
      if (!this.supplierId) return;
      this.loading = true;
      try {
        const res = await warehouseService.getSupplierRestaurants(this.supplierId);
        this.restaurants = res.data?.data ?? res.data ?? [];
      } catch (e) {
        this.showErrorSnackbar(this.$t("error"));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
